import React from 'react';
import { ProductFeedbackWrapper, ProductFeedbackContainer } from './Component';
import { Image, ImageContainer } from '../common/ui/Image';
import CutomButton from '../common/ui/CutomButton';
import BadgeWrapper from '../common/ui/BadgeWrapper';
import BannerInfo from '../BannerInfo';
import { onButtonClick } from '../../utils/helpers';

const ProductFeedback = ({ feedbackData }) => (
    <ProductFeedbackContainer
        sBackground={`url(${feedbackData.firstImgSrc}) no-repeat 100% 60%, url(${feedbackData.secondImgSrc}) no-repeat 0% 50%, #f2f8fe`}
    >
        {/* <ImageContainer
            maxWidth="470px"
            padding="0px 0px 0px 0px"
            width="unset"
            margin="0px 0px 0px -14%"
            sMargin="-10% auto 10px"
            borderRadius="6px"
            width="90%"
        >
            <Image
                style={{ borderRadius: "8px" }}
                width="100%"
                {...feedbackData.leftImg}
            />
        </ImageContainer> */}
        <ProductFeedbackWrapper>
            <BannerInfo margin='0 auto' iconWidth="21px" iconjContent="center" sJContent="space-around" sDisplay="flex" />
            <div style={{
                maxWidth: "max-content",
                margin: "0px auto"
            }}>
                <BadgeWrapper
                    mDisplay='none'
                    justifyContent="space-between"
                    margin="30px auto"
                    width="265px"
                    marginLeft="0px 10px 0px 0px"
                    marginRight="0px 0px 0px 10px"
                    appLink='https://chqbook.app.link/nQGZqUy2L9'
                />
                {feedbackData.downloadAppLinkDesktopView && <CutomButton
                    size="md"
                    weight="bold"
                    height="40px"
                    width="100%"
                    display="block"
                    sdisplay="none"
                    margin="40px auto 0px"
                    smargin="5px auto 0px"
                    mmargin="40px auto 0px"
                    padding="1px 10px 0px"
                    color="WHITE"
                    backgroundcolor="CHQBOOK_BLUE"
                    boxshadow="0 4px 8px 1px rgba(0, 0, 0, 0.08)"
                    onClick={onButtonClick.bind(null, feedbackData.link, feedbackData.external)}
                >
                    {feedbackData.downloadAppLinkDesktopView.content}
                    {feedbackData.downloadAppLinkDesktopView.androidImgSrc && <ImageContainer
                        width='13px'
                        margin="0px 5px 0px"
                    >
                        <Image
                            src={`${feedbackData.downloadAppLinkDesktopView.androidImgSrc}`}
                        />
                    </ImageContainer>}
                    {feedbackData.downloadAppLinkDesktopView.iosImgSrc && <ImageContainer
                        width='13px'
                        margin="0px 5px 0px"
                    >
                        <Image
                            src={`${feedbackData.downloadAppLinkDesktopView.iosImgSrc}`}
                        />
                    </ImageContainer>}
                </CutomButton>}
            </div>
        </ProductFeedbackWrapper>
    </ProductFeedbackContainer>
);

export default ProductFeedback;
